import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, Download, Mail, Calendar, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Confirmation() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(`xlook_order_${orderId}`);
    if (saved) setOrder(JSON.parse(saved));
  }, [orderId]);

  if (!order) {
    return (
      <div className="container-k py-16 text-center">
        <p>Order not found.</p>
        <Link to="/" className="text-xlook-orange">Back home</Link>
      </div>
    );
  }

  return (
    <div className="container-k py-8 md:py-12 max-w-3xl">
      <div className="text-center mb-8">
        <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-3" style={{ background: '#e6f7ea' }}>
          <CheckCircle2 className="w-9 h-9 text-green-600" />
        </div>
        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">Booking confirmed!</h1>
        <p className="text-sm text-gray-500 mt-1">Order #{order.id} · A confirmation email has been sent to {order.contact.email || 'you'}.</p>
      </div>

      <div className="bg-white border border-gray-100 rounded-xl p-4 md:p-6 mb-4">
        <div className="font-semibold mb-3">Your bookings</div>
        <div className="space-y-3">
          {order.items.map((item) => (
            <div key={`${item.id}-${item.packageId}`} className="flex gap-3 pt-3 border-t border-gray-50 first:border-t-0 first:pt-0">
              <img src={item.image} alt={item.title} className="w-20 h-20 rounded-lg object-cover" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold line-clamp-2">{item.title}</div>
                <div className="text-xs text-gray-600 mt-0.5">{item.packageName} · x{item.qty}</div>
                <div className="flex flex-wrap gap-3 mt-1 text-[11px] text-gray-500">
                  <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {item.city}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {item.date}</span>
                </div>
              </div>
              <div className="text-sm font-extrabold" style={{ color: '#ff5b00' }}>${(item.price * item.qty).toFixed(2)}</div>
            </div>
          ))}
        </div>
        <div className="h-px bg-gray-100 my-4" />
        <div className="flex justify-between font-bold"><span>Total paid</span><span style={{ color: '#ff5b00' }}>${order.total.toFixed(2)}</span></div>
      </div>

      <div className="flex flex-col md:flex-row gap-3">
        <Button variant="outline" className="flex-1 rounded-full h-11"><Download className="w-4 h-4 mr-2" /> Download vouchers</Button>
        <Button variant="outline" className="flex-1 rounded-full h-11"><Mail className="w-4 h-4 mr-2" /> Email vouchers</Button>
        <Link to="/" className="flex-1"><Button className="w-full rounded-full bg-xlook-orange hover:opacity-90 text-white h-11">Continue shopping</Button></Link>
      </div>
    </div>
  );
}
